import React from 'react'
import { Link } from 'gatsby'

import * as styles from 'global/layout/header/components/Logo.module.scss'

export const Logo = () => {
  return (
    <Link to="/">
      <img className={styles.logoSVG} src="/img/logo.svg" alt="logo" />
    </Link>
  )
}
